import { useCallback } from 'react';
import { TableHeaderVariant, TableWithHeader } from './shared/TableWithHeader';
import { DataTableRow } from '../../common/table/TableTypes';
import {
  ConfigurationType,
  DependenciesContentViewType,
  SelectedDependencyWithClearHistoryProps,
} from '../dependencies/types';
import { TableTypography } from '../../common/table/utils';
import { TableItemHighlightedText } from '../dependencies/search/highlight/TableItemHighlightedText';
import { PossibleSectionInDependencies } from '../dependencies/search/types';
import { NameProperties } from '../../parser/ParserTypes';

const columns = [
  { field: 'label', headerName: 'Label', width: '200px' },
  { field: 'name', headerName: 'API Name' },
];

const renderRows = ({
  items,
  section = 'dependencies',
}: {
  items: NameProperties[];
  section?: PossibleSectionInDependencies;
}) => {
  return items.map((row, index) => ({
    id: row.name,
    label: (
      <TableTypography>
        <TableItemHighlightedText
          text={row.label}
          field="label"
          section={section}
          tableType="objects"
          rowIndex={index}
        />
      </TableTypography>
    ),
    name: (
      <TableTypography>
        <TableItemHighlightedText
          text={row.name}
          field="name"
          section={section}
          tableType="objects"
          rowIndex={index}
        />
      </TableTypography>
    ),
    _nameStr: row.name, //needed in onRowClick
    isClickable: true,
  }));
};

interface ObjectTableProps {
  items: NameProperties[];
  onItemClick: (props: SelectedDependencyWithClearHistoryProps) => void;
  headerVariant?: TableHeaderVariant;
  clearHistory?: boolean;
  section?: PossibleSectionInDependencies;
}

export const ObjectsTable = ({
  items,
  onItemClick,
  headerVariant,
  clearHistory,
  section = 'dependencies',
}: ObjectTableProps) => {
  const onRowClick = useCallback(
    (e: React.MouseEvent<HTMLTableCellElement, MouseEvent>, row: DataTableRow) => {
      onItemClick({
        id: row.id,
        name: row._nameStr,
        parentType: ConfigurationType.objects,
        clearHistory,
        contentType: DependenciesContentViewType.default,
      });
    },
    [onItemClick, clearHistory],
  );

  return (
    <TableWithHeader
      tableHeader="Objects"
      columns={columns}
      rows={renderRows({ items, section })}
      headerVariant={headerVariant}
      onRowClick={onRowClick}
      dataTableType="objects"
      section={section}
    />
  );
};
